/**
 * Schema definition for Property Left Form
 */

import { BuiltInFormSchema } from '../types/builtInFormSchema';

export const propertyLeftFormSchema: BuiltInFormSchema = {
  formId: 'property_left',
  formTitle: 'Property Left',
  
  sections: [
    // Section 1: Left Side Elevation
    {
      id: 'left_elevation',
      title: 'Left Side Elevation',
      fields: [
        {
          id: 'leftElevationImage',
          type: 'photo',
          label: 'Left Elevation',
          required: true,
          maxPhotos: 999
        },
        {
          id: 'roofTypeEvidenceImages',
          type: 'photo',
          label: 'Roof Type Evidence',
          required: true,
          maxPhotos: 999,
          helpText: 'Left elevation roof images'
        },
        {
          id: 'leftSideImages',
          type: 'photo',
          label: 'Additional Left Side Images',
          maxPhotos: 999
        }
      ]
    },
    
    // Section 2: Guttering & Drainage
    {
      id: 'guttering_left',
      title: 'Guttering & Drainage',
      fields: [
        {
          id: 'gutteringDrainageImages',
          type: 'photo',
          label: 'Guttering & Drainage Photos (Left)',
          maxPhotos: 999
        }
      ]
    },
    
    // Section 3: External Wall Details (Left)
    {
      id: 'wall_left',
      title: 'External Wall Details (Left)',
      fields: [
        {
          id: 'externalWallType',
          type: 'dropdown',
          label: 'External Wall Type',
          required: true,
          options: [
            { value: '', label: 'Select Wall Type' },
            { value: 'brick', label: 'Brick' },
            { value: 'stone', label: 'Stone' },
            { value: 'concrete', label: 'Concrete' },
            { value: 'timber', label: 'Timber Frame' },
            { value: 'render', label: 'Render' },
            { value: 'other', label: 'Other' }
          ]
        },
        {
          id: 'externalWallCondition',
          type: 'dropdown',
          label: 'External Wall Condition',
          required: true,
          options: [
            { value: '', label: 'Select Condition' },
            { value: 'excellent', label: 'Excellent' },
            { value: 'good', label: 'Good' },
            { value: 'fair', label: 'Fair' },
            { value: 'poor', label: 'Poor' },
            { value: 'very_poor', label: 'Very Poor' }
          ]
        },
        {
          id: 'wallTypeEvidenceImage',
          type: 'photo',
          label: 'Wall Type Evidence',
          required: true,
          maxPhotos: 999
        },
        {
          id: 'isWallInsulated',
          type: 'boolean',
          label: 'Is the Wall Insulated?',
          required: true,
          style: 'yes-no-na'
        },
        {
          id: 'hasWallDefects',
          type: 'boolean',
          label: 'Additional visible wall defects?',
          style: 'yes-no'
        },
        {
          id: 'wallDefectImages',
          type: 'photo',
          label: 'Images of Wall Defects (Left)',
          required: true,
          maxPhotos: 999,
          conditionalOn: {
            fieldId: 'hasWallDefects',
            value: true
          }
        }
      ]
    },
    
    // Section 4: Additional Notes
    {
      id: 'notes_left',
      title: 'Additional Notes',
      fields: [
        {
          id: 'additionalNotes',
          type: 'textarea',
          label: 'Additional Notes for Property Left',
          rows: 3,
          placeholder: 'Enter any other relevant details for the left side of the property...'
        }
      ]
    }
  ],
  
  defaultSectionOrder: [
    'left_elevation',
    'guttering_left',
    'wall_left',
    'notes_left'
  ]
};
